export default "__VITE_ASSET__CYQS_slt__"